// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfi_a"};